"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.authentication = void 0;
const axios_api_1 = __importDefault(require("axios_api"));
const hawk_1 = require("hawk");
const General_1 = __importDefault(require("./constants/General"));
const environment_1 = require("./constants/environment");
const utils_1 = require("./utils");
const BASE_DEFAULT_TIMEOUT = 60000; // 60 seconds
const BASE_API_URL = process.env.API_URL + `/api`;
const BASE_ADMIN_API_URL = process.env.ADMIN_API_URL + `/api`;
const BASE_BFF_API_URL = process.env.BFF_API_URL + `/api`;
const axiosInstance = axios_api_1.default.create({
    baseURL: BASE_API_URL,
});
const getFullUrl = (url, baseUrl = '') => {
    if (baseUrl) {
        return baseUrl + url;
    }
    return BASE_API_URL + url;
};
const authentication = ({ access_token = '', secret = '', url = '', method = 'GET', }) => {
    const { header } = hawk_1.client.header(url, method, {
        credentials: {
            id: access_token,
            key: secret,
            algorithm: 'sha256',
        },
    });
    return header;
};
exports.authentication = authentication;
const fetchCookieToken = () => {
    return (0, utils_1.getCookie)(General_1.default.COOKIE_NAME);
};
const fetchImpersonateCookieToken = () => {
    return (0, utils_1.getCookie)(General_1.default.COOKIE_NAME_IMPERSONATION);
};
const request = ({ url = '', method = 'GET', data = {}, params = {}, headers = {}, admin = false, authenticated = true, impersonate = false, debug = false, access_token = '', secret = '', baseUrl = '', fullResponse = false, bff = false, timeout, config, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    if (!method) {
        console.error('[API]: Error - Method required');
        return;
    }
    const token = access_token && secret
        ? { access_token, secret }
        : (impersonate && fetchImpersonateCookieToken()) || fetchCookieToken();
    if (!(token === null || token === void 0 ? void 0 : token.access_token) && authenticated && !environment_1.isTestEnvironment) {
        console.error('[API]: Error - No token found');
        return;
    }
    const urlBase = admin ? BASE_ADMIN_API_URL : baseUrl || BASE_API_URL;
    const urlWithParams = url + (0, utils_1.getObjectToQueryString)(params);
    const fullUrl = getFullUrl(urlWithParams, urlBase);
    const urlBaseBff = (bff && !environment_1.isTestEnvironment && BASE_BFF_API_URL) || '';
    const fullUrlBff = getFullUrl(urlWithParams, urlBaseBff);
    debug &&
        environment_1.isDevMode &&
        /* eslint-disable-next-line */
        console.log(`🌈 [API]: Running ${method} -> ${urlWithParams}`, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (url && { url })), (urlWithParams && { urlWithParams })), (fullUrl && { fullUrl })), (urlBase && { urlBase })), (!!method && { method })), (impersonate && { impersonate })), (!(0, utils_1.isObjectEmpty)(data) && { data })), (!(0, utils_1.isObjectEmpty)(params) && { params })), (!(0, utils_1.isObjectEmpty)(headers) && { headers })));
    try {
        const response = yield axiosInstance.request(Object.assign({ url: bff && !environment_1.isTestEnvironment ? fullUrlBff : fullUrl, method,
            data, timeout: timeout !== null && timeout !== void 0 ? timeout : BASE_DEFAULT_TIMEOUT, headers: Object.assign(Object.assign(Object.assign({}, headers), (authenticated &&
                !environment_1.isTestEnvironment && {
                Authorization: (0, exports.authentication)({
                    access_token: token === null || token === void 0 ? void 0 : token.access_token,
                    secret: token === null || token === void 0 ? void 0 : token.secret,
                    url: fullUrl,
                    method,
                }),
            })), (bff &&
                !environment_1.isTestEnvironment && {
                baseUrl: admin ? BASE_ADMIN_API_URL : baseUrl || BASE_API_URL,
                fullUrl,
            })) }, config));
        debug &&
            environment_1.isDevMode &&
            /* eslint-disable-next-line */
            console.log(`✅ [API]: Result ${method} -> ${urlWithParams}`, response === null || response === void 0 ? void 0 : response.data);
        if (fullResponse) {
            return response;
        }
        return response === null || response === void 0 ? void 0 : response.data;
    }
    catch (error) {
        const errorReponse = {
            code: error === null || error === void 0 ? void 0 : error.code,
            message: error === null || error === void 0 ? void 0 : error.message,
            data: (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data,
            status: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status,
            errorList: ((_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorList) || [],
        };
        console.error(`❌ [API]: Error ${urlWithParams}`, errorReponse);
        return Promise.reject(errorReponse);
    }
});
exports.request = request;
//# sourceMappingURL=api.js.map